import { COUNTRY_MAP } from "@/constants/country";
import { Image, Typography } from "@backpac/monica";

export const CountryFlag = ({ countryCode }: { countryCode: string }) => {
  if (countryCode === "ETC") {
    return countryCode;
  }
  const country = COUNTRY_MAP.get(countryCode);
  return (
    <div className="flex flex-row items-center gap-3">
      <Image
        src={`https://flagcdn.com/${countryCode.toLowerCase()}.svg`}
        width="30px"
        className="flex-shrink-0 border border-borderLight"
        alt={country?.name ?? ""}
      />
      <Typography size="xs" color="textPrimary">
        {country?.name} ({countryCode})
      </Typography>
    </div>
  );
};
